import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RankingsListComponent } from './rankings-list/rankings-list.component';
import { RankingsCreateComponent } from './rankings-create/rankings-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: RankingsListComponent,
        data: {
          title: "Rankings List",
          breadcrumb: "Rankings List"
        }
      },
      {
        path: 'create',
        component: RankingsCreateComponent,
        data: {
          title: "Create Rankings",
          breadcrumb: "Create Rankings"
        }
      },
      {
        path: 'edit/:id',
        component: RankingsCreateComponent,
        data: {
          title: "Edit Rankings",
          breadcrumb: "Edit Rankings"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class RankingsRoutingModule { }
